import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Lock } from 'lucide-react';
import { Button } from '../ui/button';
import { Switch } from '../ui/switch';
import { Label } from '../ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';

export function CookieSettings({ open, onClose, onSave, onAcceptAll, onRejectAll, initialFunctional = false }) {
  const { t } = useTranslation();
  const [functional, setFunctional] = useState(initialFunctional);

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t('gdpr.settings.title')}</DialogTitle>
        </DialogHeader>

        <div className="space-y-3 py-2">
          {/* Essential — always on, cannot be disabled */}
          <div className="flex items-start justify-between gap-4 p-3 rounded-lg bg-muted/50">
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium">{t('gdpr.settings.essential.title')}</span>
                <Lock className="h-3 w-3 text-muted-foreground" />
              </div>
              <p className="text-sm text-muted-foreground mt-1">
                {t('gdpr.settings.essential.description')}
              </p>
            </div>
            <Switch checked disabled aria-label={t('gdpr.settings.essential.title')} />
          </div>

          {/* Functional — user can toggle */}
          <div className="flex items-start justify-between gap-4 p-3 rounded-lg border">
            <div className="flex-1">
              <Label htmlFor="functional-toggle" className="text-sm font-medium cursor-pointer">
                {t('gdpr.settings.functional.title')}
              </Label>
              <p className="text-sm text-muted-foreground mt-1">
                {t('gdpr.settings.functional.description')}
              </p>
            </div>
            <Switch
              id="functional-toggle"
              checked={functional}
              onCheckedChange={setFunctional}
            />
          </div>
        </div>

        <div className="flex flex-col-reverse sm:flex-row gap-2 pt-2">
          <Button variant="outline" size="sm" className="sm:flex-1" onClick={onRejectAll}>
            {t('gdpr.settings.rejectAll')}
          </Button>
          <Button variant="outline" size="sm" className="sm:flex-1" onClick={onAcceptAll}>
            {t('gdpr.settings.acceptAll')}
          </Button>
          <Button size="sm" className="sm:flex-1" onClick={() => onSave(functional)}>
            {t('gdpr.settings.save')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
